import React from 'react';
import './PercentileCompare.css';
import { compareCopy } from '../../lib/neighbourhood/scoreModel';
import { useLanguage } from '../../context/LanguageContext';

// Replaces the old ranked-list "How X compares" panel.
// Renders two directional lines:
//   1. City-relative percent diff (positive integer, framed as "better" or "worse")
//   2. National percentile with metric-appropriate verb in the matching direction
// Both lines get a dot in the matching tone:
//   pos     → green
//   neutral → brand gold
//   neg     → muted amber (informational, not alarming)
export default function PercentileCompare({
  metricKey,
  city,
  score,
  cityAvg,
  cityDiffPercent,
  nationalPercentile,
}) {
  const { t } = useLanguage();
  const { city: cityLine, national: nationalLine } = compareCopy({
    metricKey,
    city,
    cityDiff: cityDiffPercent,
    percentile: nationalPercentile,
  });

  return (
    <div className="nd-percentile">
      <div className="nd-percentile__title">{t('neighbourhoodCompare.title')}</div>

      <div className={`nd-percentile__row nd-percentile__row--${cityLine.tone}`}>
        <div className="nd-percentile__row-dot" />
        <div className="nd-percentile__row-text">{cityLine.text}</div>
      </div>

      <div className={`nd-percentile__row nd-percentile__row--${nationalLine.tone}`}>
        <div className="nd-percentile__row-dot" />
        <div className="nd-percentile__row-text">{nationalLine.text}</div>
      </div>

      <div className="nd-percentile__bar" aria-hidden="true">
        <div className="nd-percentile__bar-track" />
        <div className="nd-percentile__bar-marker" style={{ left: `${Math.max(2, Math.min(98, score))}%` }} />
        {typeof cityAvg === 'number' && (
          <div className="nd-percentile__bar-avg" style={{ left: `${Math.max(2, Math.min(98, cityAvg))}%` }} title={`${city}${t('neighbourhoodCompare.cityAverageTitleMid')}${cityAvg}`} />
        )}
        <div className="nd-percentile__bar-labels">
          <span>0</span>
          <span>100</span>
        </div>
      </div>

      <div className="nd-percentile__legend">
        <span className="nd-percentile__legend-item">
          <span className="nd-percentile__legend-dot nd-percentile__legend-dot--you" />
          {t('neighbourhoodCompare.thisNeighbourhood')}
        </span>
        {typeof cityAvg === 'number' && (
          <span className="nd-percentile__legend-item">
            <span className="nd-percentile__legend-dot nd-percentile__legend-dot--avg" />
            {city}{t('neighbourhoodCompare.cityAverageSuffix')}
          </span>
        )}
      </div>
    </div>
  );
}
